import { Button, Grid, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import CloudDownloadIcon from '@mui/icons-material/CloudDownload'
import AppShortcutRoundedIcon from '@mui/icons-material/AppShortcutRounded'
import AppleIcon from '@mui/icons-material/Apple' // Import Apple icon for iPhone button
import { mt } from 'date-fns/locale'

const titleDesription = [
  {
    title: 'Shuttering & Scaffolding billing, Online and Offline',
    description:
      'Our billing software offers fast, accurate, and easy billing solutions for businesses of all sizes. With our user-friendly interface and advanced features, managing your bills has never been easier. Save time and increase efficiency with our billing software.',
  },
]

function GetStartedA() {
  const boxShadow = '1px 1px 5px #dddddd'

  const [title, setTitle] = useState(titleDesription[0].title)
  const [description, setDescription] = useState(titleDesription[0].description)
  
  function setIndex(index: number) {
    setTitle(titleDesription[index].title)
    setDescription(titleDesription[index].description)
  }

  useEffect(() => {
    setIndex(0)
  }, [])

  return (
    <Grid
      container
      rowSpacing={2}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      sx={{
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
      <Grid item xs={12} md={5} sx={{ display: 'flex', alignItems: 'center' }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item>
            <Typography
              variant="h2" // Use smaller variant for mobile
              sx={{ 
                height: { xs: 'auto', md: 80 }, 
                backgroundColor: 'white',
                textAlign: { xs: 'center', md: 'left' }, // Center text on mobile
              }}
            >
              {title}
            </Typography>
          </Grid>
          <Grid item>
            <Typography 
              variant="subtitle1" 
              sx={{ 
                height: { xs: 'auto', md: 100 }, 
                textAlign: { xs: 'center', md: 'left' } // Center text on mobile
              }}>
              {description}
            </Typography>
          </Grid>
          <Grid item>
            <Grid container columnSpacing={{ xs: 1, sm: 2, md: 1}} justifyContent={{ xs: 'center', md: 'flex-start' }}>
              <Grid item mb={1}>
                <Button
                  variant="contained"
                  sx={{ backgroundColor: '#37A239' }}
                  onClick={() => {
                    window.open('/login')
                  }}
                >
                  GET STARTED
                </Button>
              </Grid>
              <Grid item mb={1}>
                <Button
                  sx={{ backgroundColor: '#34A853' }}
                  variant="contained"
                  onClick={() => {
                    window.open(
                      'https://play.google.com/store/apps/details?id=com.pad.rental.shuttering.store.shutteringapp'
                    )
                  }}
                  startIcon={<AppShortcutRoundedIcon />}
                >
                  ANDROID
                </Button>
              </Grid>
              <Grid item mb={1}>
                <Button
                  sx={{ backgroundColor: '#0070C9' }}
                  variant="contained"
                  onClick={() => {
                    window.open('https://apps.apple.com/in/app/id6605935322')
                  }}
                  startIcon={<AppleIcon />}
                >
                  IPHONE
                </Button>
              </Grid>
              
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={7}>
        <div
          style={{
            borderRadius: 1,
            borderStyle: 'solid',
            borderWidth: 0,
            borderLeftWidth: { xs: 0, md: 0.5 }, // Remove left border on mobile
            borderColor: '#d0d0d0',
            overflow: 'hidden',
            marginLeft: { xs: 0, md: 50 }, // Remove margin on mobile
            padding: { xs: 20, md: 40 }, // Reduce padding on mobile
            backgroundColor: 'white',
          }}
        >
          <img
            alt="shuttering"
            src={require('./images/all.jpg')}
            style={{
              width: '100%', // Make image responsive
              maxWidth: 600,
              paddingBottom: 0,
            }}
          />
        </div>
      </Grid>
    </Grid>
  )
}

export default GetStartedA
